import { Component, OnInit } from '@angular/core';
import { IntegratorService, Integrator } from 'app/services/integrator.service';
import { UserService } from 'app/services/user.service';
import { TableColumn, CommonTableService } from 'app/services/common-table.service';
import { MatDialogRef } from '@angular/material';
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'app-integrator-select',
	templateUrl: './integrator-select.component.html',
	styleUrls: ['./integrator-select.component.css']
})
export class IntegratorSelectComponent implements OnInit {

	public integrators: Integrator[] = [];
	public selectedIntegrator: Integrator;

	public currentIntegrators: Integrator[] = [];
	public columns: TableColumn[] = [];

	constructor(
		private dialogRef: MatDialogRef<IntegratorSelectComponent>,
		private toastr: ToastrService,
		private integratorService: IntegratorService,
		private tableService: CommonTableService,
		private userService: UserService
	) { }

	public cancel() {
		this.dialogRef.close();
	}
	public confirm() {
		this.dialogRef.close();
	}

	public changeIntegrator() {
		
	}
	public async addIntegrator() {
		if (this.selectedIntegrator && this.userService.getUserInfo().isAdmin) {
			try {
				this.integratorService.addIntegratorClient(this.selectedIntegrator.cusId, this.userService.getUserInfo().customerId, this.userService.getUserInfo().userId);
				await this.setTable();
				this.toastr.success('Successfull invited.');
			} catch (err) {
				console.log(err);
			}
		}
	}
	private async setTable() {
		const currentIntegrators = await this.integratorService.getIntegrators(this.userService.getUserInfo().customerId);
		currentIntegrators.forEach((c) => {
			const integrator = this.integrators.find((i) => i.cusId === c.cusId);
			if (integrator) {
				integrator.isSelected = true;
			}
		});
		this.currentIntegrators = currentIntegrators;
	}
	private setColumns() {
		const meta = [
			{ name: 'Agency', prop: 'nameShort' },
		];
		const columns: TableColumn[] = [];
		meta.forEach((m) => columns.push(this.tableService.setNewColumn(m.prop, m.name, {
			width: 150
		})));
		this.columns = columns;
	}
	async ngOnInit() {
		this.setColumns();
		if (!this.integratorService.integrators || !this.integratorService.integrators.length) {
			await this.integratorService.getIntegrators(null, true);
			this.integrators = this.integratorService.integrators;
		}
		this.setTable();
	}

}
